<template>
  <div>
    <div :class="[useType == 1 ? 'bg' : 'bg1']">
      <div class="logo">
        <img
          src="https://down.baoanlailou.com/00/askriLogo.png"
          alt=""
          v-if="useType == 1"
        />
        <img
          src="https://down.baoanlailou.com/00/logo.png"
          alt=""
          v-if="useType == 0"
        />
      </div>
      <div class="btnBox1">
        <div class="btnNew" @click="openUrl()">
          <img src="https://down.baoanlailou.com/00/IOSDown.png" alt="" />
        </div>
        <div class="btnNew" @click="openUrl1()" style="margin-top: 20px;">
          <img src="https://down.baoanlailou.com/00/AndroidDown.png" alt="" />
        </div>
      </div>
    </div>
    <div v-if="model == true" class="model" @click="close">
      <div style="color: #fff;text-align: right;margin-right: 50px;">
        <div>
          <img
            src="https://down.baoanlailou.com/00/load.png"
            alt=""
            style="width: 77px;height: 60px;"
          />
        </div>
        <div
          style="display: flex;width: 100%;justify-content: end;padding-right: 35px;box-sizing: border-box;"
        >
          <div style="width: 200px;margin-right: 10px;font-size: 20px;">
            请点击右上角，使用默认浏览器打开App下载
          </div>
          <div>
            <img
              src="https://down.baoanlailou.com/00/serf1.png"
              alt=""
              style="width: 74px;height: 96px;"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      urlData: {},
      useType: 1, //0 用户端    1保安端
      model: false,
      key: ""
    };
  },
  async mounted() {
    if (this.$route.query.useType) {
      this.useType = this.$route.query.useType;
    }
    this.getCode();
    this.getList();
    setTimeout(() => {
      this.postData();
    }, 500);
  },
  methods: {
    async getCode() {
      try {
        const fp = await window.FingerprintJS.load();
        const result = await fp.get();
        this.key = result.visitorId;
      } catch (error) {
        // console.error("生成设备指纹失败:", error);
      }
    },
    isWeChatBrowser() {
      return /MicroMessenger/i.test(navigator.userAgent);
    },
    close() {
      this.model = false;
    },
    postData() {
      console.log(this.key);
      this.$axios
        .post(`/mapi/api/statistice/h5-downPage-statis`, {
          sourceFrom: 6,
          equipmentKey: this.key,
          terminalType: this.useType == 0 ? 1 : 2
        })
        .then(({ data }) => {
          console.log(data);
        })
        .catch()
        .finally();
    },
    getList() {
      this.$axios
        .post(`/mapi/api/common/invite/getAppDownloadUrl`, {
          useType: this.useType
        })
        .then(({ data }) => {
          this.urlData = data;
        })
        .catch()
        .finally();
    },
    openUrl() {
      if (this.urlData.iosUrl == "") {
        this.$message("正在建设中");
      } else {
        if (this.isWeChatBrowser()) {
          this.model = true;
        } else {
          window.location.href = this.urlData.iosUrl;
        }
      }
    },
    openUrl1() {
      if (this.urlData.androidUrl == "") {
        this.$message("正在建设中");
      } else {
        if (this.isWeChatBrowser()) {
          this.model = true;
        } else {
          window.location.href = this.urlData.androidUrl;
        }
      }
    }
  }
};
</script>
<style scoped>
.messageBox {
  width: 80%;
  height: 150px;
  background: rgba(0, 0, 0, 0.68);
  border-radius: 22px;
  position: fixed;
  top: 35vh;
  left: 10%;
  text-align: center;
  padding: 50px 20px;
  box-sizing: border-box;
  color: #fff;
  font-size: 16px;
}
.model {
  width: 100%;
  height: 100%;
  background: rgb(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
}
.btnBox {
  /* margin-top: 580px; */
  text-align: center;
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  padding: 0 0 30px 0;
  box-sizing: border-box;
}
.btn {
  width: 309px;
  background: linear-gradient(180deg, #31afff 0%, #1677ff 100%);
  border-radius: 10px;
  border: 1px solid #979797;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  line-height: 25px;
  padding: 10px 22px;
  box-sizing: border-box;
  margin: 30px auto 0;
}
.btn1 {
  width: 309px;
  background: linear-gradient(179deg, #00deb0 0%, #04b578 100%);
  border-radius: 10px;
  border: 1px solid #979797;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  line-height: 25px;
  padding: 10px 22px;
  box-sizing: border-box;
  margin: 30px auto 0;
}
.bg1 {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  padding: 0 34px;
  box-sizing: border-box;
  overflow: hidden;
  background-image: url("https://down.baoanlailou.com/00/user.png");
}
.bg {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  padding: 0 34px;
  box-sizing: border-box;
  overflow: hidden;
  background-image: url("https://down.baoanlailou.com/00/askari.png");
}
.logo {
  width: 100%;
  text-align: center;
  position: fixed;
  left: 0;
  top: 35vh;
}
.logo img {
  width: 190px;
  height: 190px;
}
.btnNew {
  width: 100%;
  text-align: center;
  margin-top: 220px;
}
.btnNew img {
  width: 240px;
  height: 45px;
}
.btnBox1 {
  text-align: center;
  position: fixed;
  bottom: 9vh;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/douyin/douyin.vue